import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface ConfirmDialogData {
	title: string;
	message: string;
	/** Rótulo do botão que confirma. Padrão: "Confirmar". */
	confirmText?: string;
	/** Rótulo do botão que cancela. Padrão: "Cancelar". */
	cancelText?: string;
	/** Pinta o botão de confirmação como ação destrutiva. */
	destructive?: boolean;
}

/**
 * Confirmação genérica, no lugar do `confirm()` do navegador.
 *
 * O `confirm()` nativo congela o renderer até alguém responder: a página
 * inteira para, não há como estilizá-lo e ele quebra automação e testes.
 */
@Component({
	templateUrl: './confirm-dialog.component.html',
	styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {
	readonly confirmText: string;
	readonly cancelText: string;

	constructor(
		private readonly dialogRef: MatDialogRef<ConfirmDialogComponent, boolean>,
		@Inject(MAT_DIALOG_DATA) readonly data: ConfirmDialogData
	) {
		this.confirmText = data.confirmText ?? 'Confirmar';
		this.cancelText = data.cancelText ?? 'Cancelar';
	}

	cancel(): void {
		this.dialogRef.close(false);
	}

	confirm(): void {
		this.dialogRef.close(true);
	}
}
